// store/store.js
import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { persistStore, persistReducer } from 'redux-persist'; // ← ADD THIS
import storage from 'redux-persist/lib/storage'; // ← ADD THIS

// Import ALL your reducers
import authReducer from './slices/authSlice';
import providerReducer from './slices/providerSlice';
import adminProviderReducer from './slices/adminProviderSlice';
import adminReducer from './slices/adminSlice';
import providerGalleryReducer from './slices/providerGalleryServiceSlice';
import providerImageReducer from './slices/providerImageSlice';
import pinCodeReducer from './slices/pinCodeSlice';
import profileReducer from './slices/profileSlice';
import serviceProviderReviewReducer from './slices/serviceProviderReviewSlice';
import serviceProviderSearchReducer from './slices/serviceProviderSearchSlice';
import reportReducer from './slices/reportSlice';
import platformSettingsReducer from './slices/platformSettingsSlice';
import messageReducer from './slices/messageSlice';
import donationReducer from './slices/donationSlice';
import serviceCategoryReducer from './slices/serviceCategorySlice';
import businessVerificationReducer from './slices/businessVerificationSlice';
import resetReducer from './slices/resetSlice';

// ==================== PERSIST CONFIG ====================

const persistConfig = {
  key: 'root',
  storage,
  whitelist: [
    'auth',
    'provider',
    'admin',
    'profile',
    'pinCode',
    'platformSettings',
    'serviceCategory',
    'adminProvider',
    'providerGallery',
  ],
  // Blacklist for reducers you DON'T want to persist
  // blacklist: ['providerImage', 'serviceProviderReview', 'serviceProviderSearch', 'report', 'message', 'donation', 'businessVerification', 'reset'],
};

// ==================== ROOT REDUCER ====================

const rootReducer = combineReducers({
  auth: authReducer,
  admin: adminReducer,
  provider: providerReducer,
  adminProvider: adminProviderReducer,
  providerImage: providerImageReducer,
  pinCode: pinCodeReducer,
  profile: profileReducer,
  serviceProviderReview: serviceProviderReviewReducer,
  serviceProviderSearch: serviceProviderSearchReducer,
  report: reportReducer,
  platformSettings: platformSettingsReducer,
  message: messageReducer,
  donation: donationReducer,
  serviceCategory: serviceCategoryReducer,
  businessVerification: businessVerificationReducer,
  providerGallery: providerGalleryReducer,
  reset: resetReducer,
});

// ==================== PERSISTED REDUCER ====================

const persistedReducer = persistReducer(persistConfig, rootReducer);

// ==================== STORE CONFIGURATION ====================

export const store = configureStore({
  reducer: persistedReducer, // ← USE PERSISTED REDUCER
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
        ignoredPaths: ['register', 'rehydrate'],
      },
      immutableCheck: {
        ignoredPaths: ['register', 'rehydrate'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store);

// Add debugging
persistor.subscribe(() => {
  const state = persistor.getState();
  console.log('🟣 Persistor state:', state);
  if (state.bootstrapped) {
    console.log('✅ Redux Persist rehydration complete');
  }
});

export default store;